import { Component, Input, Inject, OnInit } from '@angular/core';

@Component({
    selector: 'environment-menu',
    template: require('./environment-menu.component.html'),
    styles: [require('./environment-menu.component.scss')]
})
export class EnvironmentMenuComponent implements OnInit {
    @Input() public data: any;
    @Input() public dbType: any;

    public titles: any[];

    constructor(@Inject('$state') public $state: any) {
    }

    public ngOnInit() {
        const databaseType = this.dbType === 3 ? 'Schemas' : 'Databases';
        const menu = [
            { name: 'Activity', state: 'activities' },
            { name: 'Automation', state: 'automation' },
            { name: 'Settings', state: 'settings' },
            { name: 'Deployed Packages' , state: 'deployedPackages' },
            { name: databaseType, state: databaseType.toLowerCase() }
        ];

        if (this.data.environments && this.data.environments.length && this.data.environments[0].isTest) {
            this.titles = menu.filter(x => 'activities,databases,schemas'.includes(x.state));
        } else {
            this.titles = this.data.name === 'Dev'
                ? menu.filter(x => 'activities,automation,deployedPackages,databases,schemas'.includes(x.state))
                : menu.filter(x => 'activities,automation,deployedPackages,databases,schemas'.includes(x.state));
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/environmentDetails/environment-menu/environment-menu.component.ts